<template>
  <div ref="maindiv" id="addeditcontent">
    <vs-button
      v-if="isResourceContent"
      id="back-to-topic_btn"
      @click="backToTeacherResources"
      icon-pack="feather"
      icon="icon-arrow-left"
      class="float-left mb-3 school-primary_gradient glow-effect_tertiary">
      Back
    </vs-button>
    <vs-button
      v-else
      id="back-to-topic_btn"
      @click="backToTopic"
      icon-pack="feather"
      icon="icon-arrow-left"
      class="float-left mb-3 school-primary_gradient glow-effect_tertiary">
      Back
    </vs-button>

    <div class="main-div">
      <div class="vx-row limit-width_fixed-scalable">
        <div style="margin:auto" class="mb-4">
          <vx-card
            class="glow-effect_bg-color__blend card__no-padding bg-color"
            style="width: 277px"
          >
            <vx-input-group>
              <vs-button
                :disabled="true"
                size="large"
                class="button__fully-opaque glow-effect_bg-color__blend header_button-lookalike text__school-font-color bg-color"
                type="filled"
                color=""
              >
                Adding Quiz
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>

      <div>
        <v-select
          ref="quizDropdown"
          class="w-full mb-5 style-chooser"
          placeholder="Search / Select Quiz"
          :options="quizzes"
          v-model="quizDropdown"
          @search:blur="saveActive"
          :clearable="false"
        >
        <span slot="no-options" style="color: rgb(202, 202, 202)">No quizzes have been made yet.</span>
        </v-select>

        <vx-card title="Configuration">
          <div class="vx-row mt-1">
            <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-checkbox
                color="success"
                v-model="isDecisive"
                style="padding-bottom: 25px"
              >
                Decisive
              </vs-checkbox>
            </div>
            <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-checkbox
                color="success"
                v-model="allowOnlyOnce"
                style="padding-bottom: 25px"
              >
                Allow Only Once
              </vs-checkbox>
            </div>
            <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <span
                id="decisivewarning"
                class="text-danger text-sm"
                v-show="isDecisive"
                >When this is checked, students won't be allowed to do the quiz
                on their smart phones / tablets. It also means that pictures of
                the student will be taken at random intervals.</span
              >
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <locations
      :isLocationViewActive="isLocationViewActive && !isResourceContent"
      :selectedData="selectedData"
      :uploadedFileUrl="selectedQuiz"
      @save="save"
    />

    <div v-if="isResourceContent" class="vx-row mt-5" id="add-location-button">
      <vs-spacer></vs-spacer>
      <div class="vx-col w-1/3 xs:w-full sm:w-3/5 md:w-2/5 lg:w-2/5 xl:w-1/5">
        <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="SaveIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="!selectedQuiz"
              size="large"
              class="w-full button-text__left-align glow-effect_primary school-primary_gradient"
              style="border-radius:0 7px 7px 0"
              @click="saveWithoutLocations">
              Save
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Locations from "./Locations.vue";

export default {
  components: {
    Locations,
    "v-select": vSelect
  },
  data() {
    return {
      isLocationViewActive: true,
      selectedData: {},
      selectedQuiz: null,
      activePrompt: false,
      numberOfTasks: null,
      isTeacher: false,
      quizzes: [],
      quizDropdown: 0,
      allowOnlyOnce: 0,
      isDecisive: false,
      isResourceContent: false
    };
  },
  computed: {
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    }
  },
  methods: {
    initValues() {
      var self = this;
      self.quizDropdown = 0;
      self.allowOnlyOnce = 0;
      self.isDecisive = false;
    },
    saveWithoutLocations() {
      var self = this;
      if(self.quizDropdown) {
        if (self.selectedQuiz) {
          self.showLoadingOnElement('maindiv', 1, 'material');

          var quizToAddInfo = {
            name: self.quizDropdown.label,
            selectedQuizId: self.quizDropdown.value,
            modules: [],
            number: self.numberOfTasks + 1,
            allowOnlyOnce: self.allowOnlyOnce,
            standalone: true,
            isDecisive: self.isDecisive
          };

          quizToAddInfo.modules.push(self.selectedData.selectedResource.topicId);

          var onSuccess = response => {
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: `Quiz saved`,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
            self.backToTeacherResources();
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.maindiv.$el);
          };

          self.$ajaxPost(
            self,
            "Quiz/AddEditQuiz",
            quizToAddInfo,
            onSuccess,
            onFinally
          );
        } else {
          self.$vs.notify({
            title: "Warning",
            color: "warning",
            text: "Please select a quiz",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info",
            time: 5500
          });
        }
      }
      else {
        self.$vs.notify({
          title: "Warning",
          color: "warning",
          text: "Please ensure that you have selected at least one allow type",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-info",
          time: 5500
        });
      }
    },
    backToTopic() {
      var self = this;
      self.activePrompt = false;
      self.$vs.loading.close(self.$refs.maindiv.$el);
      if (self.isTeacher)
        self.$router.push({
          name: "TeacherBrowseContent",
          params: { selectedData: self.selectedData, navFromAddContent: true }
        });
      else
        self.$router.push({
          name: "BrowseContent",
          params: { selectedData: self.selectedData, navFromAddContent: true }
        });
    },
    backToTeacherResources() {
      var self = this;
      self.$vs.loading.close(self.$refs.maindiv.$el);
      self.$router.push({ name: 'TeacherResources'});
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    getQuiz() {
      var self = this;
      var onSuccess = response => {
        self.quizzes = response.data.map(item => {
          return { label: item.text, value: item.value };
        });
        self.quizDropdown = 0;
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.quizDropdown.$el);
      };
      self.$ajaxGet(self, "quiz/getselectlist", onSuccess, onFinally);
    },
    saveActive() {
      var self = this;
      self.selectedQuiz = self.quizDropdown;
    },
    save(allLocations) {
      var self = this;

      if (self.quizDropdown) {
        if (self.selectedQuiz) {
          self.showLoadingOnElement("maindiv", 1, "material");

          var quizToAddInfo = {
            name: self.quizDropdown.label,
            selectedQuizId: self.quizDropdown.value,
            modules: allLocations,
            number: self.numberOfTasks + 1,
            allowOnlyOnce: self.allowOnlyOnce,
            standalone: true,
            isDecisive: self.isDecisive
          };

          var onSuccess = response => {
            self.$vs.notify({
              title: "Information",
              color: "success",
              text: `Quiz saved & added to ${allLocations.length} location(s).`,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
            self.backToTopic();
          };

          var onFinally = function() {
            self.$vs.loading.close(self.$refs.maindiv.$el);
          };

          self.$ajaxPost(
            self,
            "Quiz/AddEditQuiz",
            quizToAddInfo,
            onSuccess,
            onFinally
          );
        } else {
          self.$vs.notify({
            title: "Warning",
            color: "warning",
            text: "Please select a quiz",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info",
            time: 5500
          });
        }
      } else {
        self.$vs.notify({
          title: "Warning",
          color: "warning",
          text: "Please ensure that you have selected at least one allow type",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-info",
          time: 5500
        });
      }
    }
  },
  mounted() {
    var self = this;
    self.initValues();

    self.selectedData = self.$route.params.selectedData;
    self.numberOfTasks = self.$route.params.numberOfTasks;
    self.isTeacher = self.$route.params.isTeacher;
    self.isResourceContent = self.$route.params.isResourceContent;

    self.showLoadingOnElement("quizDropdown", 0.45, "material");
    self.getQuiz();
  }
};
</script>

<style lang="scss">
.main-div {
  width: 65%;
}

@media screen and (max-width: 900px) {
  .main-div {
    width: 100%;
  }
}

.filepond--panel-root {
  border-radius: 0 6px 6px 0;
  background-color: rgba(255, 255, 255, 0) !important;
}

.filepond--drop-label {
  color: rgb(202, 202, 202) !important;
}

.decisivewarning {
  text-align: left !important;
}

#videoname.vs-input--input {
  background: none !important;
  border: 5px solid rgba(192, 196, 212, 0.2) !important;
  border-radius: 20px !important;
  height: 55px !important;
  font-size: 1.4rem !important;
  color: rgb(202, 202, 202) !important;
}

#videoDesc.vs-textarea {
  background: rgba(var(--vs-background), 1) !important;
  border-radius: 20px !important;
  border: 5px solid rgba(192, 196, 212, 0.2) !important;
  color: rgb(202, 202, 202) !important;
  font-size: 1rem !important;
  height: 90px !important;
}

// #videodetails .vs-con-input-label {
//   width: 400px !important;
// }

#videodetails .focusx.vs-textarea-primary {
  border: 0 solid rgba(0, 0, 0, 0) !important;
}

#videodetails .vs-textarea-primary {
  border: 0 solid rgba(0, 0, 0, 0) !important;
}

.save__btn {
  border-radius: 15px !important;
}

#back-to-topic_btn {
  border-radius: 15px !important;
}
</style>
